import type { ReactElement } from 'react';
import { useMount } from '@simplywallst/ui-core';
interface Props {
  children: ReactElement;
  onMount?: () => void;
}
export function MountWrapper(props: Props) {
  useMount(() => {
    props.onMount?.();
  });
  return props.children;
}
